import { fetch } from '../fetchWrapper/fetch';
import { API_URL } from '../constants';
import { IUpdateVenueChannelsBody, IUpdateVenueChannelsResponse, IUpdateVenueChannelsData } from './';

export const updateVenueChannels = async (
  venueId: string,
  requestBody: IUpdateVenueChannelsBody,
): Promise<IUpdateVenueChannelsData> => {
  try {
    const response = await fetch(`${API_URL}/venues/${venueId}/channels`, {
      method: 'PATCH',
      body: JSON.stringify(requestBody),
      headers: {
        'Content-Type': 'application/json',
      },
    });

    if (!response.ok) {
      throw new Error();
    }

    const { data }: IUpdateVenueChannelsResponse = await response.json();
    return data[0];
  } catch (e) {
    throw new Error('Something went wrong whilst updating venue channels');
  }
};
